customElements.whenDefined('shopify-account').then(() => {
  const trigger = document.querySelector('shopify-account');
  const dialog = trigger && trigger.shadowRoot && trigger.shadowRoot.querySelector('dialog.dialog');
  if (!dialog) return;

  function position() {
    if (!window.matchMedia('(min-width: 750px)').matches) {
      dialog.style.top = '';
      dialog.style.right = '';
      dialog.style.left = '';
      return;
    }
    const rect = trigger.getBoundingClientRect();
    dialog.style.left = 'auto';
    dialog.style.right = (window.innerWidth - rect.right) + 'px';
    dialog.style.top = (rect.bottom + 12) + 'px';
  }

  new MutationObserver(position).observe(dialog, { attributes: true, attributeFilter: ['open'] });
  window.addEventListener('resize', position);
});
